import { render } from "./candlestickChart.vue?vue&type=template&id=50e12ff0"
import script from "./candlestickChart.vue?vue&type=script&lang=js"
export * from "./candlestickChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__